import React from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import './Footer.css';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', id: 'home', type: 'scroll' },
    { name: 'Our Services', route: '/services', type: 'route' },
    { name: 'About Us', route: '/about-us', type: 'route' },
    { name: 'Our Experts', route: '/team', type: 'route' },
    { name: 'Testimonials', id: 'testimonials', type: 'scroll' },
    { name: 'Contact Us', id: 'contact', type: 'scroll' },
  ];

  const locations = [
    { name: 'Dubai, Abu Dhabi, UAE' },
    { name: 'Riyadh, Saudi Arabia' },
  ];

  const handleScrollLink = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = `/#${id}`;
    }
  };

  return (
    <footer className="ft">
      <div className="ft__body">
        <div className="ft__inner">

          {/* Col 1 — Brand */}
          <div className="ft__col ft__col--brand">
            <img
              src={`${config.imageBaseURL}${config.paths.img}logo.webp`}
              alt="CFO Bridge UAE"
              className="ft__logo"
            />
            <p className="ft__tagline">
              Strategic financial leadership for businesses across the UAE and beyond.
            </p>
            <a
              href="https://www.linkedin.com/company/cfobridge-uae/"
              target="_blank"
              rel="noopener noreferrer"
              className="ft__linkedin"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                <circle cx="4" cy="4" r="2" />
              </svg>
              Follow on LinkedIn
            </a>
          </div>

          {/* Col 2 — Quick Links */}
          <div className="ft__col">
            <h4 className="ft__col-title">Quick Links</h4>
            <ul className="ft__list">
              {quickLinks.map((item) => (
                <li key={item.name}>
                  {item.type === 'route' ? (
                    <Link to={item.route} className="ft__link">{item.name}</Link>
                  ) : (
                    <a
                      href={`#${item.id}`}
                      className="ft__link"
                      onClick={(e) => handleScrollLink(e, item.id)}
                    >
                      {item.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Locations */}
          <div className="ft__col">
            <h4 className="ft__col-title">Locations</h4>
            <ul className="ft__list">
              {locations.map((loc) => (
                <li key={loc.name}>
                  <a
                    href={loc.link}
                    className="ft__link ft__link--loc"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    {loc.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Contact Details */}
          <div className="ft__col">
            <h4 className="ft__col-title">Contact Details</h4>
            <ul className="ft__contact-list">
              <li>
                <a href="tel:+971501674938" className="ft__contact-item">
                  <span className="ft__ci">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .99h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                    </svg>
                  </span>
                  <span>+971 50 167 4938</span>
                </a>
              </li>
              <li>
                <a href="mailto:vidya@cfobridge.com" className="ft__contact-item">
                  <span className="ft__ci">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  <span>vidya@cfobridge.com</span>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="ft__bottom">
        <div className="ft__bottom-inner">
          <p className="ft__copy">
            Copyright © 2026 by CFO Bridge Pvt. Ltd &nbsp;|&nbsp;
            <a href="https://cfobridge.com" className="ft__btm-link">cfobridge.com</a>
          </p>
          <a href="https://cfobridge.com/privacy-policy" className="ft__btm-link">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;